/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import {
  ConsumptionMeta,
  ConsumptionAction,
  ActionNames as TransportControlActions,
  Ducks,
} from '@wit/vtv-x-foundation-lib';
import { SagaIterator } from 'redux-saga';
import { put, select, spawn } from 'redux-saga/effects';
import { Creators as BookmarksCreators } from './bookmarks';

export function* error(meta: ConsumptionMeta): SagaIterator {
  yield put(BookmarksCreators.setBookmark({ action: ConsumptionAction.ERROR, ...meta }));
}

export function* play(meta: ConsumptionMeta): SagaIterator {
  const isSsmEnabled: boolean = yield select(Ducks.Dms.Selectors.isSsmEnabled);
  if (!isSsmEnabled) {
    yield put(BookmarksCreators.setBookmark({ action: ConsumptionAction.PLAY, ...meta }));
  }

  yield spawn(Ducks.TransportControlEvents.addTransportControlEvent, TransportControlActions.PLAY, meta);
}

export function* stop(meta: ConsumptionMeta): SagaIterator {
  const isSsmEnabled: boolean = yield select(Ducks.Dms.Selectors.isSsmEnabled);
  if (!isSsmEnabled) {
    yield put(BookmarksCreators.setBookmark({ action: ConsumptionAction.STOP, ...meta }));
  }

  yield spawn(Ducks.TransportControlEvents.addTransportControlEvent, TransportControlActions.STOP, meta);
}

export function* pause(meta: ConsumptionMeta): SagaIterator {
  const isSsmEnabled: boolean = yield select(Ducks.Dms.Selectors.isSsmEnabled);
  if (!isSsmEnabled) {
    yield put(BookmarksCreators.setBookmark({ action: ConsumptionAction.PAUSE, ...meta }));
  }

  yield spawn(Ducks.TransportControlEvents.addTransportControlEvent, TransportControlActions.PAUSE, meta);
}

export function* firstPlay(meta: ConsumptionMeta): SagaIterator {
  const isSsmEnabled: boolean = yield select(Ducks.Dms.Selectors.isSsmEnabled);
  if (!isSsmEnabled) {
    yield put(BookmarksCreators.setBookmark({ action: ConsumptionAction.FIRST_PLAY, ...meta }));
  }

  yield spawn(Ducks.TransportControlEvents.addTransportControlEvent, TransportControlActions.PLAY, meta);
}

export function* bitrateChange(meta: ConsumptionMeta): SagaIterator {
  yield put(BookmarksCreators.setBookmark({ action: ConsumptionAction.BITRATE_CHANGE, ...meta }));
}

export function* load(meta: ConsumptionMeta): SagaIterator {
  yield put(BookmarksCreators.setBookmark({ action: ConsumptionAction.LOAD, ...meta }));
}

export function* seek(meta: ConsumptionMeta, previousMeta: ConsumptionMeta): SagaIterator {
  yield spawn(Ducks.TransportControlEvents.addTransportControlEvent, TransportControlActions.SEEK, meta, previousMeta);
}

export function* zap(meta: ConsumptionMeta, previousMeta: ConsumptionMeta): SagaIterator {
  yield spawn(
    Ducks.TransportControlEvents.addTransportControlEvent,
    TransportControlActions.CHANNEL_TUNED,
    meta,
    previousMeta
  );
}

export function* startOver(meta: ConsumptionMeta): SagaIterator {
  yield spawn(Ducks.TransportControlEvents.addTransportControlEvent, TransportControlActions.START_OVER, meta);
}

export function* volumeChange(meta: ConsumptionMeta, previousMeta?: ConsumptionMeta): SagaIterator {
  yield spawn(
    Ducks.TransportControlEvents.addTransportControlEvent,
    TransportControlActions.VOLUME,
    meta,
    previousMeta
  );
}
